import { render, staticRenderFns } from "./media-preview-IMAGE.vue?vue&type=template&id=66dc6e90&"
import script from "./media-preview-IMAGE.vue?vue&type=script&lang=js&"
export * from "./media-preview-IMAGE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66dc6e90')) {
      api.createRecord('66dc6e90', component.options)
    } else {
      api.reload('66dc6e90', component.options)
    }
    module.hot.accept("./media-preview-IMAGE.vue?vue&type=template&id=66dc6e90&", function () {
      api.rerender('66dc6e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-file-preview/types/media-preview-IMAGE.vue"
export default component.exports